import './About.css';
function About() {
    return <h1 className="about-style">This is an application developed by Melvin Safari Kukwan with the aim of enhancing 
      good moods to peoples hearts and faces by providing them with reasons to smile hence avoiding negative energy
    </h1>;
  }
  export default About;